import { Injectable } from '@angular/core';
import { CrudService } from '../crud.service';
import { BookmarkCategory } from '../../models/bookmark-category';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BookmarkCategoryService extends CrudService<BookmarkCategory> {
  protected basePath = 'bookmarkcategory'; // Specific for BookmarkService
  public instanceType = 'bookmarkcategory'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
